import axios from "axios"
import { del, get, getNodeAdminAPI, getNodeLystlocAPI, post, put } from "./api_helper"
import * as url from "./url_helper"

const Countries = data => getNodeAdminAPI(url.COUNTRIES)
const CountriesAndStates = data => getNodeLystlocAPI(url.COUNTRIESANDSTATES)

const LystfaceSignup = data => post(url.LYSTFACE_SIGNUP_USER, data)

const LystfaceSignupResend = data => post(url.LYSTFACE_SIGNUP_RESEND, data)

const LystfaceLogin = data => post(url.LYSTFACE_LOGIN_USER, data)
const LystfaceLogout = data => post(url.LYSTFACE_LOGOUT_USER, data)


const LystfaceForgotPassword = data => post(url.LYSTFACE_FORGOT_PASSWORD, data)

const LystfaceForgotPasswordUpdate = (pwdId, data) => {
  return post(`${url.LYSTFACE_FORGOT_PASSWORD_UPDATE}${pwdId}`, data)
}
const LystfaceForgotPasswordVerify = pwdId => get(`${url.LYSTFACE_FORGOT_PASSWORD_VERIFY}${pwdId}`)

const LystfaceVerifyUser = data => post(url.LYSTFACE_VERIFY_USER, data)

const LystfacePayMethAdd = payMethId => post(url.LYSTFACE_ADD_CARD, payMethId)
const LystfacePayMethList = data => get(url.LYSTFACE_PAYMENT_METHOD_LIST)
const LystfacePayMethRemove = payMethId => post(url.LYSTFACE_PAYMENT_METHOD_REMOVE, payMethId)
const LystfaceDefPayMeth = payMethId => post(url.LYSTFACE_PAYMENT_METHOD_DEFAULT, payMethId)
const LystfaceCmpInv = search => post(url.LYSTFACE_PAYMENT_INVOICES, search)
const LystfaceCmpActPlan = () => get(url.LYSTFACE_COMPANY_ACTIVE_PLAN)
const LystfaceAddBillAddress = (address) => post(url.LYSTFACE_ADD_BILL_ADDRESS, address)
const LystfaceGetBillAddress = (address) => get(url.LYSTFACE_GET_BILL_ADDRESS)
const LystfaceEditBillAddress = (address) => post(url.LYSTFACE_EDIT_BILL_ADDRESS, address)
const LystfaceTimezonesList = () => get(url.LYSTFACE_TIMEZONES)
const LystfaceUpdateTimeZone = (data) => post(url.LYSTFACE_TIMEZONES, data)
const LystfacePayMethIntent = payMethId => post(url.LYSTFACE_ADD_INTENT, payMethId)




// const LystfacePayMeth
//Home Page
const LystfacePlanSpecificationDetails = () => get(url.LYSTFACE_PLAN_SPECIFICATION_DETAILS)
const LystfaceGetStartedSection = (data) => post(url.LYSTFACE_GETSTARTED_SECTION, data)
const LystfaceGetTransactionLimit = (data) => get(url.LYSTFACE_TRANSACTION_LIMIT)



//Application page 
const LystfaceAppsList = () => get(url.LYSTFACE_APPS_LIST)
const LystfaceCreateApp = (data) => post(url.LYSTFACE_CREATE_APP, data)
const LystfaceEditApp = (data) => post(url.LYSTFACE_EDIT_APP, data)
const LystfaceRegenerateAppKey = (data) => post(url.LYSTFACE_REGENERATE_APP_KEY, data)
const LystfaceGetAccountSetting = () => get(url.LYSTFACE_GET_ACCOUNT_SETTING_PROFILE);
const LystfaceChangePassword = (data) => post(url.CHANGE_PASSWORD_API, data)
const LystfaceEditAccountSetting = (data) => post(url.EDIT_ACCOUNT_SETTING, data)
const LystfaceDeleteApp = (data) => post(url.LYSTFACE_DELETE_APP, data)

//Email and Phone Verification
const LystfaceVerifyOTP = (data) => post(url.LYSTFACE_VERIFY_OTP, data)
const LystfaceResendOTP = (data) => post(url.LYSTFACE_RESEND_OTP, data)
const LystfaceTwoFactorAuth = (data) => post(url.LYSTFACE_TWO_FACTOR_AUTH, data)
const LystfaceVerifyCurrentPswd = (data) => post(url.LYSTFACE_VERIFY_CURRENT_PSWD, data)
const LystfaceSendEmail = (data) => post(url.LYSTFACE_SEND_EMAIL, data)
const LystfaceUpdateContact = (data) => post(url.LYSTFACE_UPDATE_CONTACT, data)
const LystfaceVerifyLoginOTP = (data) => post(url.LYSTFACE_VERIFY_LOGIN_OTP, data)
const LystfaceResendLoginOTP = (data) => post(url.LYSTFACE_RESEND_LOGIN_OTP, data)
const LystfaceVerifyEmail = (data) => post(url.LYSTFACE_VERIFY_EMAIL, data)




// Plan Page
const LystfacePlanAdd = (plan) => post(url.LYSTFACE_PLAN_ADD, plan)

//usage
const UsageDetails = (startDate, endDate, granularity, appId) => get(`${url.USAGE_DETAILS}?start_dt=${startDate}&end_dt=${endDate}&granularity=${granularity}&app_id=${appId}`)
const UsageDetailsForAllApps = (startDate, endDate, granularity, appId) => get(`${url.USAGE_DETAILS}?start_dt=${startDate}&end_dt=${endDate}&granularity=${granularity}`)

//constants
const LystfaceConstDetails = () => get(`${url.CONST_DETAILS}`)

//pricing
const LystfaceGetPlanList = () => get(url.GET_PLANS_LIST)
const LystfaceCancelSubscription = () => post(url.CANCEL_SUBSCRIPTION)
const LystfaceCheckPlanLimit = (data) => post(url.CHECK_PLAN_LIMIT, data)
const LystfaceCheckEstimationDetails = (data) => post(url.GET_ESTIMATION, data)
const LystfaceUpgradePlan = (data) => post(url.UPGRADE_PLAN, data)
const LystfaceDownGradePlan = (data) => post(url.DOWNGRADE_PLAN, data)
const LystfaceCancelSchedule = (data) => post(url.CANCEL_SCHEDULE, data)



export {
  LystfaceCmpActPlan,
  LystfacePlanAdd,
  LystfaceEditBillAddress,
  LystfaceAddBillAddress,
  LystfaceGetBillAddress,
  LystfacePayMethRemove,
  LystfaceCmpInv,
  LystfaceDefPayMeth,
  LystfaceSignup,
  LystfaceLogin,
  LystfaceForgotPassword,
  LystfaceForgotPasswordUpdate,
  LystfaceVerifyUser,
  LystfaceForgotPasswordVerify,
  LystfaceSignupResend,
  Countries,
  LystfacePayMethAdd,
  LystfacePayMethList,
  LystfacePlanSpecificationDetails,
  LystfaceAppsList,
  LystfaceCreateApp,
  LystfaceEditApp,
  LystfaceRegenerateAppKey,
  LystfaceGetAccountSetting,
  LystfaceChangePassword,
  LystfaceEditAccountSetting,
  UsageDetails,
  LystfaceConstDetails,
  LystfaceDeleteApp,
  LystfaceLogout,
  LystfaceTimezonesList,
  LystfaceUpdateTimeZone,
  UsageDetailsForAllApps,
  CountriesAndStates,
  LystfacePayMethIntent,
  LystfaceGetStartedSection,
  LystfaceTwoFactorAuth,
  LystfaceResendOTP,
  LystfaceVerifyOTP,
  LystfaceUpdateContact,
  LystfaceSendEmail,
  LystfaceVerifyCurrentPswd,
  LystfaceResendLoginOTP,
  LystfaceVerifyLoginOTP,
  LystfaceVerifyEmail,
  LystfaceGetPlanList,
  LystfaceCancelSubscription,
  LystfaceCheckPlanLimit,
  LystfaceCheckEstimationDetails,
  LystfaceUpgradePlan,
  LystfaceDownGradePlan,
  LystfaceGetTransactionLimit,
  LystfaceCancelSchedule
}
